import {ProjectStrategy} from './project-strategy.interface';

let _activeStrategy: ProjectStrategy | null = null;

export function registerStrategy(strategy: ProjectStrategy): void {
  _activeStrategy = strategy;
}

export function getStrategy(): ProjectStrategy {
  if(!_activeStrategy) {
    throw new Error('No strategy registered — check active-strategy.ts fileReplacement.');
  }
  return _activeStrategy;
}
